import { Tooltip } from '@mantine/core';
import { Icon, variants } from '@uag/react-core';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';

import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';
import { PRIMARY_COLOR_ACCENT_HEX } from 'shared/constants';

export const ArticleSelectionInfo = () => {
    const { t } = useTranslation();

    const selectedArticlesCount = usePlacementStore(
        useShallow((state) => Object.keys(state.articleInstanceSelections).length)
    );

    return (
        <Tooltip label={t('labelSelectedArticlesCount')} position="bottom" variant={variants.tooltip.bottom}>
            <div className="flex items-center justify-between h-full w-full">
                <Icon className="icon-medium" color={PRIMARY_COLOR_ACCENT_HEX} icon="select_all" />
                <div className="text-xs leading-none tabular-nums text-right w-7">{selectedArticlesCount.toString()}</div>
            </div>
        </Tooltip>
    );
};
